import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useKitSyncStatusQuery = createQueryHook(
  CreatorIntegrationsApiClient.getKitSyncStatus,
  {
    queryKey: ['kitSyncStatus'],
  },
)
